<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useLocale } from '@/composables/useLocale'
import LocaleFlag from '@/components/layout/LocaleFlag.vue'

const { t } = useI18n()
const { availableLocales, changeLocale, currentLocale } = useLocale()
</script>

<template>
  <footer class="bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 no-print">
    <div class="section-container py-12 md:py-16">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
        <div class="md:col-span-2">
          <p class="text-sm text-muted dark:text-dark-muted leading-relaxed max-w-xl">
            {{ t('footer.disclaimer') }}
          </p>
        </div>

        <div>
          <h3 class="text-sm font-semibold text-text dark:text-dark-text mb-3">
            {{ t('nav.language') }}
          </h3>
          <div class="flex flex-wrap gap-2">
            <button
              v-for="loc in availableLocales"
              :key="loc.code"
              type="button"
              class="inline-flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg transition-colors"
              :class="[
                loc.code === currentLocale
                  ? 'bg-primary text-white'
                  : 'bg-slate-200 dark:bg-slate-700 text-text dark:text-dark-text hover:bg-slate-300 dark:hover:bg-slate-600',
              ]"
              @click="changeLocale(loc.code)"
            >
              <LocaleFlag :locale="loc.code" size="sm" />
              {{ loc.native }}
            </button>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-x-6 gap-y-2 pt-8 border-t border-slate-200 dark:border-slate-700 text-sm text-muted dark:text-dark-muted">
        <span>{{ t('footer.last_updated') }}: 2026-03-14</span>
        <button type="button" class="hover:text-text dark:hover:text-dark-text transition-colors" @click="() => globalThis.print()">
          {{ t('footer.print_version') }}
        </button>
        <button type="button" class="hover:text-text dark:hover:text-dark-text transition-colors">
          {{ t('footer.accessibility') }}
        </button>
        <button type="button" class="hover:text-text dark:hover:text-dark-text transition-colors">
          {{ t('footer.submit_correction') }}
        </button>
        <button type="button" class="hover:text-text dark:hover:text-dark-text transition-colors">
          {{ t('footer.contact') }}
        </button>
      </div>
    </div>
  </footer>
</template>
